import React, { ReactElement } from 'react';

import { Icon as SidebarIcon } from '@iconify/react';

import { ReactComponent as ResearcherIcon2 } from '~/assets/icons/researcher-sidebar-icon2.svg';
import router from '~/core/router';
import { sidebar } from '~/core/sidebar';
import {
  AdvancedArticleGeneratorRoute,
  AiDetectorRoute,
  AiHumanizerRoute,
  AiResearcherRoute,
  FactCheckerRoute,
  FileConverterRoute,
  PaperWriterRoute,
  ParaphraseTextRoute,
  PlagiarismCheckerRoute,
  QuizGeneratorRoute,
  RewriteArticleRoute,
  SummarizeTextRoute,
  ToolRoute,
  ToolsGalleryRoute,
} from '~/modules/tools';
import {
  AiResearcherSidebarKey,
  FileConverterSidebarKey,
  ToolsSidebarKey,
} from '~/modules/tools/constants';
import { GB_FEATURE_KEYS, GB_FEATURES } from '~/services/abTests/features';
import analytics from '~/services/analytics';

router.addPrivateRoutes([
  ToolsGalleryRoute,
  AdvancedArticleGeneratorRoute,
  PaperWriterRoute,
  PlagiarismCheckerRoute,
  AiDetectorRoute,
  AiHumanizerRoute,
  ParaphraseTextRoute,
  SummarizeTextRoute,
  RewriteArticleRoute,
  AiResearcherRoute,
  FactCheckerRoute,
  QuizGeneratorRoute,
  FileConverterRoute,
  ToolRoute,
]);

sidebar.addItems({
  a: [
    {
      order: 2,
      key: ToolsSidebarKey,
      path: ToolsGalleryRoute.path,
      getTitle: ToolsGalleryRoute.getTitle,
      onClickCb: (): void => {
        analytics.trackEvent('side_menu_click', {
          button: 'tools',
        });
      },
      Icon: ({ isActive }): ReactElement => {
        return (
          <SidebarIcon
            icon={isActive ? `flowbite:grid-solid` : `flowbite:grid-outline`}
          />
        );
      },
    },
    {
      order: 6,
      key: FileConverterSidebarKey,
      path: FileConverterRoute.path,
      getTitle: FileConverterRoute.getTitle,
      checkAvailability: (profile): boolean => {
        const variant =
          profile.backend_ab_tests[GB_FEATURE_KEYS.EXPERIMENT_FILE_CONVERTER];

        return (
          variant !==
          GB_FEATURES[GB_FEATURE_KEYS.EXPERIMENT_FILE_CONVERTER].variants
            .control
        );
      },
      onClickCb: (): void => {
        analytics.trackEvent('side_menu_click', {
          button: 'file_converter',
        });
      },
      Icon: ({ isActive }): ReactElement => {
        return (
          <SidebarIcon
            icon={
              isActive
                ? 'material-symbols:file-export-rounded'
                : 'material-symbols:file-export-outline-rounded'
            }
          />
        );
      },
    },
    {
      order: 4,
      key: AiResearcherSidebarKey,
      path: AiResearcherRoute.path,
      getTitle: AiResearcherRoute.getTitle,
      getLabel: (): string => '',
      onClickCb: (): void => {
        analytics.trackEvent('side_menu_click', {
          button: 'ai_researcher',
        });
      },
      Icon: (): ReactElement => <ResearcherIcon2 />,
    },
  ],
});
